import { IconChevronLeft, IconChevronRight } from '../incidents/icons';

interface RidesPaginationProps {
  page: number;
  limit: number;
  /** Nombre d'éléments de la page courante — le back ne renvoie pas de total. */
  pageSize: number;
  onPageChange: (page: number) => void;
}

export const RidesPagination = ({ page, limit, pageSize, onPageChange }: RidesPaginationProps) => {
  const start = pageSize === 0 ? 0 : (page - 1) * limit + 1;
  const end = (page - 1) * limit + pageSize;

  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-sm text-zinc-500 font-mono tabular-nums">
        {pageSize === 0 ? 'Aucune course' : `${start}–${end}`}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="inline-flex items-center gap-1.5 h-8 px-3 text-sm text-zinc-700 bg-white border border-zinc-200 rounded-md hover:bg-zinc-50 hover:border-zinc-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-zinc-200 transition-colors duration-100"
        >
          <IconChevronLeft width={14} height={14} />
          <span>Précédent</span>
        </button>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={pageSize < limit}
          className="inline-flex items-center gap-1.5 h-8 px-3 text-sm text-zinc-700 bg-white border border-zinc-200 rounded-md hover:bg-zinc-50 hover:border-zinc-300 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-zinc-200 transition-colors duration-100"
        >
          <span>Suivant</span>
          <IconChevronRight width={14} height={14} />
        </button>
      </div>
    </div>
  );
};
